import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddResults = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 175,
	viewBox: "0 0 200 175",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_546_8729)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_546_8729",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 0,
					y: 24,
					width: 200,
					height: 151,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M199.817 24.8135H0.150391V174.933H199.817V24.8135Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask0_546_8729)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M130.699 36.3076H8.08143C4.35936 36.3076 1.34204 39.3382 1.34204 43.0767V73.6192C1.34204 77.3575 4.35936 80.3883 8.08143 80.3883H130.699C134.421 80.3883 137.439 77.3575 137.439 73.6192V43.0767C137.439 39.3382 134.421 36.3076 130.699 36.3076Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M137.439 63.8965V77.7473C137.439 79.2064 134.512 80.3876 130.923 80.3876H7.86598C4.26615 80.3876 1.3501 79.2064 1.3501 77.7473V69.7302C9.64594 71.9376 19.0912 73.4261 28.7785 74.3508C40.4853 75.4678 52.5513 75.7938 64.5667 75.8419C78.9341 75.9007 93.541 75.5506 107.065 73.5918C119.458 71.8013 130.949 68.501 137.439 63.8965Z",
							fill: "#DAE9ED"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M130.572 81.5078H7.95378C5.88524 81.5057 3.90198 80.6796 2.43905 79.2106C0.976119 77.7419 0.152964 75.7502 0.150146 73.6724V43.1273C0.152964 41.0497 0.976119 39.058 2.43905 37.5891C3.90198 36.1202 5.88524 35.2941 7.95378 35.292H130.572C132.641 35.2941 134.624 36.1206 136.087 37.5901C137.55 39.0595 138.373 41.0519 138.375 43.13V73.6751C138.372 75.7523 137.548 77.7432 136.086 79.2117C134.622 80.6799 132.64 81.5057 130.572 81.5078ZM7.95378 37.4299C6.44954 37.4313 5.00726 38.0319 3.94336 39.1001C2.87945 40.1681 2.28076 41.6165 2.27865 43.1273V73.6724C2.28006 75.1837 2.87844 76.6329 3.94242 77.7016C5.00641 78.7702 6.44909 79.3712 7.95378 79.3726H130.572C132.076 79.3712 133.519 78.7702 134.583 77.7016C135.647 76.6329 136.245 75.1837 136.247 73.6724V43.1273C136.245 41.616 135.647 40.167 134.583 39.0983C133.519 38.0296 132.076 37.4286 130.572 37.4272L7.95378 37.4299Z",
							fill: "#A096B1"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M192.16 104.72H52.0009C48.2789 104.72 45.2615 107.751 45.2615 111.489V142.032C45.2615 145.77 48.2789 148.801 52.0009 148.801H192.16C195.882 148.801 198.9 145.77 198.9 142.032V111.489C198.9 107.751 195.882 104.72 192.16 104.72Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M198.9 132.309V146.16C198.9 147.619 195.606 148.8 191.543 148.8H52.6181C48.5553 148.8 45.2615 147.619 45.2615 146.16V138.143C54.6269 140.35 65.2907 141.839 76.2259 142.763C89.428 143.88 103.061 144.206 116.628 144.255C132.841 144.313 149.337 143.963 164.604 142.004C178.602 140.214 191.575 136.914 198.9 132.309Z",
							fill: "#DAE9ED"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M100.808 104.83C86.3337 105.701 66.2193 104.859 53.7383 108.063C47.8131 109.581 46.3524 112.526 45.3972 114.961L45.4158 108.143C45.4158 107.269 45.4983 106.318 47.0708 105.65C49.0157 104.827 52.4293 104.763 55.4358 104.765C70.197 104.771 86.339 104.183 100.808 104.83Z",
							fill: "#4ED9FF"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M192.392 149.921H52.2297C50.161 149.918 48.1778 149.092 46.715 147.623C45.2519 146.155 44.429 144.163 44.426 142.085V111.54C44.4282 109.462 45.2511 107.47 46.7139 106C48.177 104.531 50.1608 103.704 52.2297 103.702H192.392C194.461 103.704 196.444 104.531 197.907 106C199.37 107.47 200.193 109.462 200.195 111.54V142.085C200.192 144.163 199.369 146.155 197.906 147.623C196.444 149.092 194.46 149.918 192.392 149.921ZM52.2297 105.843C50.7253 105.844 49.2833 106.445 48.2193 107.513C47.1553 108.581 46.5567 110.029 46.5545 111.54V142.085C46.5559 143.597 47.1542 145.046 48.2182 146.114C49.2822 147.183 50.7251 147.784 52.2297 147.785H192.392C193.896 147.784 195.339 147.183 196.403 146.114C197.467 145.046 198.066 143.597 198.067 142.085V111.54C198.066 110.029 197.467 108.58 196.403 107.511C195.339 106.442 193.896 105.842 192.392 105.84L52.2297 105.843Z",
							fill: "#A096B1"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 26.27,
							y: 26.1196,
							width: 152.799,
							height: 138.433,
							rx: 4.92537,
							fill: "#ECEAF1"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M172.911 166.141H32.7677C30.6988 166.139 28.715 165.312 27.252 163.843C25.7891 162.374 24.9662 160.381 24.9641 158.303V32.6515C24.9662 30.5734 25.7891 28.581 27.252 27.1115C28.715 25.6421 30.6988 24.8156 32.7677 24.8135H172.911C174.98 24.8156 176.964 25.6421 178.427 27.1115C179.89 28.581 180.713 30.5734 180.715 32.6515V158.306C180.712 160.384 179.889 162.375 178.426 163.844C176.963 165.313 174.98 166.139 172.911 166.141ZM32.7677 26.9514C31.2631 26.9528 29.8203 27.5538 28.7563 28.6225C27.6923 29.6911 27.094 31.1402 27.0926 32.6515V158.306C27.094 159.817 27.6923 161.266 28.7563 162.335C29.8203 163.404 31.2631 164.005 32.7677 164.006H172.911C174.416 164.005 175.859 163.404 176.923 162.335C177.987 161.266 178.585 159.817 178.586 158.306V95.4787V32.6515C178.585 31.1402 177.987 29.6911 176.923 28.6225C175.859 27.5538 174.416 26.9528 172.911 26.9514H32.7677Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M161.908 34.6909H43.9307C41.6003 34.6909 39.7109 36.5885 39.7109 38.9293V150.3C39.7109 152.641 41.6003 154.538 43.9307 154.538H161.908C164.239 154.538 166.128 152.641 166.128 150.3V38.9293C166.128 36.5885 164.239 34.6909 161.908 34.6909Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M165.907 38.1049V58.7526H39.5273V38.1049C39.5273 36.521 41.3359 35.2358 43.5674 35.2358H161.867C164.099 35.2358 165.907 36.521 165.907 38.1049Z",
							fill: "#DAE9ED"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M162.132 156.273H44.1597C42.7587 156.272 41.4156 155.712 40.425 154.717C39.4342 153.722 38.8771 152.373 38.8757 150.966V38.727C38.8779 37.3203 39.4353 35.9719 40.4258 34.9775C41.4164 33.983 42.7592 33.4238 44.1597 33.4224H162.132C163.533 33.4238 164.876 33.9834 165.867 34.9784C166.858 35.9734 167.415 37.3225 167.416 38.7297V150.969C167.414 152.376 166.857 153.724 165.866 154.718C164.876 155.713 163.533 156.272 162.132 156.273ZM44.1597 35.5603C43.3232 35.5617 42.5213 35.8961 41.9299 36.4901C41.3384 37.0842 41.0056 37.8895 41.0042 38.7297V150.969C41.0064 151.808 41.3395 152.613 41.9309 153.207C42.5224 153.8 43.3238 154.134 44.1597 154.136H162.132C162.969 154.134 163.77 153.8 164.362 153.206C164.953 152.611 165.286 151.806 165.288 150.966V38.727C165.286 37.8873 164.952 37.0827 164.361 36.4892C163.769 35.8957 162.968 35.5617 162.132 35.5603H44.1597Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M153.935 50.7354H51.5005V55.2784H153.935V50.7354Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 72.8439H78.394V71.7349H52.0884V72.8439Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 75.2868H109.343V74.1777H52.0884V75.2868Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 77.7291H78.394V76.6201H52.0884V77.7291Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 80.171H109.343V79.062H52.0884V80.171Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 82.6134H78.394V81.5044H52.0884V82.6134Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 85.0543H109.343V83.9453H52.0884V85.0543Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 94.9147H78.394V93.8057H52.0884V94.9147Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 97.3576H109.343V96.2485H52.0884V97.3576Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 99.8004H78.394V98.6914H52.0884V99.8004Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 102.242H109.343V101.133H52.0884V102.242Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 104.685H78.394V103.576H52.0884V104.685Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 107.125H109.343V106.016H52.0884V107.125Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 116.986H78.394V115.877H52.0884V116.986Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 119.428H109.343V118.319H52.0884V119.428Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 121.871H78.394V120.762H52.0884V121.871Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 124.313H109.343V123.204H52.0884V124.313Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 126.756H78.394V125.646H52.0884V126.756Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0884 129.196H109.343V128.087H52.0884V129.196Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M140.887 40.9966C140.887 41.6408 141.409 42.163 142.053 42.163H159.467C160.112 42.163 160.634 41.6408 160.634 40.9966C160.634 40.3523 160.112 39.8301 159.467 39.8301H142.053C141.409 39.8301 140.887 40.3523 140.887 40.9966Z",
							fill: "#EEA248"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M118.416 40.9966C118.416 41.6408 118.938 42.163 119.582 42.163H136.996C137.64 42.163 138.163 41.6408 138.163 40.9966C138.163 40.3523 137.64 39.8301 136.996 39.8301H119.582C118.938 39.8301 118.416 40.3523 118.416 40.9966Z",
							fill: "#EEA248"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M45.7825 43.2444C47.0197 43.2444 48.0227 42.237 48.0227 40.9943C48.0227 39.7516 47.0197 38.7441 45.7825 38.7441C44.5453 38.7441 43.5422 39.7516 43.5422 40.9943C43.5422 42.237 44.5453 43.2444 45.7825 43.2444Z",
							fill: "#EEA248"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M124.983 125.358L117.84 132.162L132.334 147.514L139.477 140.71L124.983 125.358Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsxs("g", {
							opacity: .5,
							children: [/* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M118.785 125.601C128.094 116.734 128.485 101.966 119.657 92.6158C110.829 83.2655 96.1254 82.8735 86.8161 91.7404C77.5068 100.608 77.1165 115.376 85.9445 124.726C94.7727 134.076 109.476 134.468 118.785 125.601Z",
								fill: "#E3DFE9"
							}), /* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M90.5582 122.154C88.2088 119.667 86.4345 116.691 85.3612 113.436C84.2879 110.182 83.942 106.73 84.3485 103.326C84.7551 99.9223 85.9037 96.6505 87.7129 93.7433C89.5219 90.8363 91.947 88.3657 94.8152 86.5073C91.7462 87.6369 88.949 89.4044 86.6066 91.6941C84.2642 93.9838 82.4292 96.7441 81.2218 99.7948C80.0141 102.846 79.461 106.118 79.5988 109.398C79.7363 112.678 80.5617 115.892 82.0208 118.83C83.4796 121.767 85.5394 124.363 88.0654 126.447C90.5914 128.53 93.5267 130.055 96.6795 130.921C99.8324 131.787 103.132 131.975 106.362 131.473C109.592 130.971 112.68 129.789 115.424 128.006C111.163 129.577 106.538 129.86 102.119 128.82C97.6996 127.78 93.6807 125.463 90.5582 122.154Z",
								fill: "#6B6770"
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M128.153 83.7606C125.622 81.073 122.692 78.7951 119.466 77.0076C119.411 76.9728 119.355 76.9434 119.293 76.9141C111.837 72.8358 103.18 71.5538 94.8699 73.297C86.5591 75.0405 79.1368 79.6954 73.9291 86.4303C68.7215 93.1649 66.0683 101.54 66.4437 110.06C66.8191 118.579 70.1987 126.686 75.9783 132.932C76.0608 133.026 76.146 133.116 76.2444 133.199C78.8872 136.005 81.9645 138.363 85.3571 140.182L85.4529 140.233C92.9502 144.216 101.613 145.394 109.895 143.557C118.177 141.72 125.54 136.987 130.669 130.202C135.799 123.418 138.362 115.024 137.901 106.517C137.441 98.011 133.986 89.9458 128.153 83.7606ZM119.403 92.6168C122.564 95.9653 124.666 100.18 125.443 104.728C126.22 109.277 125.636 113.954 123.766 118.169C121.896 122.384 118.824 125.948 114.937 128.409C111.051 130.871 106.525 132.119 101.932 131.997C97.3392 131.875 92.8856 130.387 89.1344 127.723C85.3831 125.058 82.503 121.336 80.8577 117.027C79.2126 112.719 78.8763 108.017 79.8919 103.516C80.9072 99.0155 83.2286 94.9185 86.5623 91.743C88.7757 89.6345 91.381 87.9846 94.2295 86.8873C97.078 85.7903 100.113 85.2676 103.163 85.3488C106.213 85.4303 109.217 86.1142 112.003 87.3616C114.789 88.6094 117.304 90.3958 119.403 92.6195V92.6168Z",
							fill: "#ECEAF1"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M130.663 129.416C124.588 135.202 116.685 138.665 108.331 139.202C99.9756 139.74 91.6979 137.317 84.938 132.356C78.1784 127.395 73.3651 120.21 71.3361 112.052C69.3073 103.893 70.1912 95.2791 73.8341 87.708C70.8894 91.7342 68.8125 96.333 67.7365 101.211C66.6608 106.088 66.6092 111.138 67.5856 116.037C68.5618 120.935 70.5443 125.576 73.4066 129.662C76.2689 133.748 79.948 137.189 84.209 139.767C88.47 142.344 93.2192 144.001 98.1534 144.632C103.088 145.262 108.099 144.852 112.866 143.427C117.634 142.003 122.054 139.596 125.843 136.36C129.632 133.124 132.708 129.129 134.874 124.632C133.614 126.348 132.204 127.949 130.663 129.416Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M102.494 145.676C96.369 145.679 90.3411 144.137 84.9634 141.192L84.8304 141.12C77.0204 136.804 71.026 129.799 67.9513 121.395C67.8822 121.214 67.8156 121.024 67.7544 120.829C65.3258 113.81 65.0568 106.219 66.9831 99.0446C68.9092 91.8701 72.9411 85.4444 78.5539 80.6034C84.1668 75.7624 91.1004 72.7309 98.4525 71.9033C105.805 71.0754 113.234 72.4899 119.775 75.9626C119.847 75.9973 119.919 76.0374 119.988 76.0775C126.873 79.7953 132.402 85.6162 135.776 92.6988C139.15 99.7811 140.194 107.758 138.756 115.476C137.319 123.193 133.474 130.251 127.779 135.629C122.084 141.008 114.834 144.427 107.076 145.393C105.556 145.581 104.026 145.676 102.494 145.676ZM102.556 73.79C97.0145 73.7918 91.5543 75.1253 86.6311 77.679C81.7079 80.2327 77.4644 83.9324 74.2549 88.4692C71.0457 93.0061 68.9634 98.2485 68.1825 103.758C67.4016 109.268 67.9444 114.886 69.7659 120.142V120.174C69.8164 120.334 69.875 120.495 69.9335 120.652C72.8307 128.579 78.4848 135.187 85.8521 139.255L85.9452 139.306C93.2087 143.296 101.654 144.548 109.755 142.834C117.857 141.119 125.081 136.553 130.125 129.959C135.169 123.364 137.7 115.176 137.261 106.872C136.822 98.5681 133.441 90.695 127.73 84.6745C125.186 81.9722 122.226 79.6985 118.964 77.9401L118.924 77.9161L118.839 77.8706L118.799 77.8493C113.796 75.1849 108.218 73.794 102.556 73.798V73.79ZM102.556 133.066C102.335 133.066 102.117 133.066 101.896 133.066C95.4894 132.978 89.3777 130.349 84.8937 125.753C80.4097 121.156 77.9175 114.965 77.9612 108.53C78.0048 102.095 80.5803 95.9385 85.1262 91.4037C89.6719 86.869 95.8188 84.3239 102.226 84.3239C108.632 84.3239 114.779 86.869 119.325 91.4037C123.871 95.9385 126.446 102.095 126.49 108.53C126.534 114.965 124.041 121.156 119.557 125.753C115.074 130.349 108.962 132.978 102.556 133.066ZM102.526 86.4008C96.8532 86.3891 91.3944 88.5775 87.2888 92.5098C83.5684 96.0536 81.1866 100.783 80.5492 105.894C79.9117 111.004 81.0576 116.178 83.7922 120.534C86.5271 124.89 90.6808 128.16 95.5463 129.785C100.412 131.41 105.688 131.291 110.475 129.447C115.262 127.603 119.266 124.149 121.802 119.673C124.338 115.197 125.251 109.977 124.385 104.901C123.518 99.8246 120.927 95.2076 117.051 91.8356C113.175 88.4636 108.256 86.5459 103.13 86.4088C102.933 86.4088 102.735 86.4088 102.534 86.4088L102.526 86.4008Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M130.692 137.965L130.69 137.967C127.658 140.856 127.531 145.666 130.406 148.712L151.92 171.498C154.795 174.544 159.585 174.672 162.617 171.783L162.619 171.781C165.651 168.893 165.779 164.083 162.903 161.037L141.389 138.25C138.514 135.205 133.724 135.077 130.692 137.965Z",
							fill: "#7A7A7D"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M157.098 174.933H156.861C155.728 174.908 154.611 174.657 153.576 174.195C152.54 173.733 151.606 173.069 150.827 172.242L129.316 149.452C128.536 148.626 127.925 147.654 127.519 146.591C127.113 145.528 126.92 144.395 126.95 143.257C126.98 142.119 127.233 140.997 127.694 139.958C128.156 138.918 128.816 137.979 129.639 137.196C130.461 136.412 131.429 135.799 132.488 135.391C133.546 134.984 134.674 134.789 135.807 134.819C136.94 134.85 138.057 135.104 139.092 135.567C140.127 136.031 141.062 136.694 141.842 137.52L163.356 160.302C164.926 161.973 165.772 164.2 165.712 166.497C165.651 168.794 164.687 170.973 163.031 172.558C161.432 174.088 159.307 174.94 157.098 174.933ZM135.576 136.959C134.306 136.962 133.065 137.338 132.005 138.041C130.946 138.744 130.114 139.743 129.612 140.915C129.111 142.086 128.962 143.38 129.183 144.636C129.405 145.892 129.987 147.055 130.859 147.983L152.37 170.767C153.56 172.019 155.195 172.747 156.917 172.794C158.64 172.84 160.311 172.2 161.565 171.013C162.812 169.818 163.537 168.176 163.583 166.446C163.628 164.716 162.991 163.037 161.81 161.777L140.299 138.993C139.691 138.349 138.959 137.836 138.147 137.486C137.334 137.137 136.46 136.957 135.576 136.959Z",
							fill: "#35363A"
						}),
						/* @__PURE__ */ _jsxs("g", {
							opacity: .5,
							children: [/* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M137.944 140.815C140.605 143.06 142.662 145.852 145.147 148.268C145.886 148.987 147.009 147.854 146.275 147.135C143.79 144.73 141.733 141.926 139.073 139.682C138.29 139.022 137.157 140.149 137.944 140.815Z",
								fill: "#35363A"
							}), /* @__PURE__ */ _jsx("path", {
								opacity: .5,
								d: "M133.352 140.31C133.778 140.045 134.257 139.877 134.755 139.819C135.253 139.761 135.758 139.813 136.234 139.973C137.221 140.262 137.644 138.715 136.659 138.426C135.978 138.21 135.258 138.143 134.549 138.229C133.84 138.314 133.157 138.551 132.546 138.923C131.665 139.458 132.466 140.839 133.344 140.307L133.352 140.31Z",
								fill: "#35363A"
							})]
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M111.378 79.3696C115.622 80.6657 119.613 82.7394 122.928 85.6977C127.137 89.439 130 94.3508 131.75 99.6849C132.07 100.66 133.613 100.243 133.291 99.2573C131.458 93.6721 128.467 88.4904 124.059 84.5593C120.525 81.4113 116.305 79.2146 111.806 77.8196C110.822 77.5177 110.402 79.065 111.381 79.3669L111.378 79.3696Z",
							fill: "#C4BDD2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M95.8745 77.8817C98.6495 77.5129 101.526 77.6492 104.298 77.9324C105.32 78.0367 105.312 76.4332 104.298 76.329C101.526 76.0457 98.6495 75.9095 95.8745 76.2782C94.8714 76.4119 94.8581 78.0179 95.8745 77.8817Z",
							fill: "#C4BDD2"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.6357 37.7239C40.6357 36.3638 41.7383 35.2612 43.0984 35.2612H103.161V46.4851H40.6357V37.7239Z",
					fill: "#C4BDD2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M164.843 37.9656C164.843 36.6055 163.74 35.5029 162.38 35.5029H102.318V46.7268H164.843V37.9656Z",
					fill: "#F6F6F6"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0237 48.3211C51.0067 48.3211 61.5312 37.7964 61.5312 24.8136C61.5312 11.8309 51.0067 1.30615 38.0237 1.30615C25.041 1.30615 14.5163 11.8309 14.5163 24.8136C14.5163 37.7964 25.041 48.3211 38.0237 48.3211Z",
			fill: "#E3DFE9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0236 49.6269C33.1159 49.6269 28.3187 48.1715 24.2381 45.445C20.1575 42.7185 16.977 38.8431 15.099 34.3092C13.221 29.7751 12.7296 24.7859 13.687 19.9726C14.6444 15.1593 17.0077 10.7379 20.4778 7.26762C23.9481 3.79755 28.3694 1.43425 33.1828 0.476827C37.9961 -0.480658 42.9853 0.0107443 47.5196 1.88884C52.0528 3.76688 55.9282 6.94735 58.655 11.0279C61.3817 15.1083 62.8371 19.9058 62.8371 24.8134C62.8307 31.3921 60.214 37.6993 55.5623 42.3512C50.9105 47.0029 44.6022 49.6195 38.0236 49.6269ZM38.0236 2.54059C33.6181 2.54059 29.3114 3.84705 25.6484 6.29455C21.9852 8.74225 19.1303 12.221 17.4443 16.2912C15.7584 20.3614 15.3171 24.8403 16.1766 29.1612C17.0361 33.4821 19.1576 37.4511 22.2729 40.5663C25.388 43.6816 29.3571 45.8031 33.678 46.6626C37.9989 47.5221 42.4778 47.0808 46.548 45.3948C50.6186 43.7089 54.0963 40.854 56.5438 37.1908C58.9913 33.5278 60.2986 29.221 60.2986 24.8156C60.2923 18.9098 57.9442 13.2476 53.7684 9.07162C49.5905 4.89544 43.9293 2.54673 38.0236 2.54059Z",
			fill: "#35363A"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_546_8729)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M29.9431 24.1606H46.1045",
				stroke: "#35363A",
				strokeWidth: 2.46269,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M38.0239 15.6309V32.6901",
				stroke: "#35363A",
				strokeWidth: 2.46269,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_546_8729",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 199.813,
				height: 150.187,
				fill: "white",
				transform: "translate(0.150391 24.8135)"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_546_8729",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 23.5075,
				height: 24.8134,
				fill: "white",
				transform: "translate(26.27 11.7539)"
			})
		})] })
	]
});
export default SvgAddResults;
